<!--Don't touch anything or everything breaks. Even if you delete your change, it will still be broken. I don't understand it. -->
<template>
<v-container>
<v-row>
  <v-col>
      <v-card elevation='0' v-if='!activeParticipants'>
        <v-card-title>Conference Mode</v-card-title>
        <v-card-text>
          <v-select
            v-model="conf.conference_type" 
            v-on:change="selectConferenceType()"
            :items="meetingTypeOptions"
          >
          </v-select>
        </v-card-text>
        <v-card-text v-if="conf.conference_type=='Meeting'">
          In "Meeting" mode, all conference users start out unmuted.
        </v-card-text>
        <v-card-text v-if="conf.conference_type=='Presentation'">
          In "Presentation" mode, only leaders start out unmuted. Guests joining in via the web or dial-in will be muted.
        </v-card-text>
      </v-card>
      <v-card elevation='0' disabled v-if='activeParticipants'>
        <v-card-title>Conference Mode</v-card-title>
        <v-card-text>
          <v-select
            v-model="conf.conference_type" 
            v-on:change="selectConferenceType()"
            :items="meetingTypeOptions"
          >
          </v-select>
        </v-card-text>
        <v-card-text v-if="conf.conference_type=='Meeting'">
          In "Meeting" mode, all conference users start out unmuted.
        </v-card-text>
        <v-card-text v-if="conf.conference_type=='Presentation'">
          In "Presentation" mode, only leaders start out unmuted. Guests joining in via the web or dial-in will be muted.
        </v-card-text>
      </v-card>
  </v-col>
</v-row>
<v-row>
  <v-col>
    <v-card elevation='0'>
      <v-card-title>
        Access Codes
      </v-card-title>
      <v-list>
        <v-list-item>
          <b>Leader PINS</b>
          <v-spacer></v-spacer>
          <v-btn @click="addLeaderPin" icon color="primary"><v-icon>mdi-plus</v-icon></v-btn>
        </v-list-item>
        <v-list-item v-for="pin in conf.pins" :key='pin.pin' v-if="pin.is_admin=='Y'">               
            {{pin.pin}}
            <v-spacer></v-spacer>
            
            <v-btn icon color="red" v-on:click="deleteConferencePin(pin)">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
        </v-list-item>
      </v-list>
      <br>
      <v-list>
        <v-list-item>
          <b>Guest PINS</b>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click="addGuestPin"><v-icon>mdi-plus</v-icon></v-btn>
        </v-list-item>
        <v-list-item v-for="pin in conf.pins" :key='pin.pin' v-if="pin.is_admin=='N'">               
            {{pin.pin}} (https://join.rinble.com/{{pin.url_token}})
            <v-spacer></v-spacer>
            
            <v-btn icon color="red" v-on:click="deleteConferencePin(pin)">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
        </v-list-item>
      </v-list>
      <v-card-text>
        Conferences require one admin pin and one guest pin.
      </v-card-text>
    </v-card>
  </v-col>
</v-row>
<v-row>
  <v-col>
    <conference-permissions></conference-permissions>
  </v-col>
</v-row>
</v-container>
</template>

<script >
let updateConferenceMutationTxt = `
    mutation updateConferenceMutation($conferenceId: Int!, $emailAddress: String!, $conferenceType: String!) {
      conferenceUpdate(conferenceId:$conferenceId, emailAddress:$emailAddress, conferenceType:$conferenceType) {
        conference_id
        name
        user_id
        record
        transcribe
        email_address
        share_with_account
        conference_type
        pins {
            pin
            is_admin
            is_active
            token
        }
        users {
            user_id
            first_name
            last_name
            user_id
            username
        }
        ActiveSession {
          conference_session_id
          conference_id
          start_time
          end_time
        }
        Participants {
          conference_session_participant_id
          conference_session_id
          name
          email
          phone_number
          start_time
          end_time
          token
          is_caller
          is_admin
          is_rinble_phone
          is_muted
          bill_minutes
          bill_rate
          asterisk_uniqueid
          asterisk_channel
        }
      }
    }
  `;


  let deletePinMutationTxt = `
    mutation conferenceDeletePinMutation($conferenceId: Int!, $pin: Int!) {
      conferenceDeletePin(conferenceId:$conferenceId, pin:$pin) {
        conference_id
        name
        user_id
        record
        transcribe
        email_address
        share_with_account
        conference_type
        pins {
            pin
            is_admin
            is_active
            token
        }
        users {
            user_id
            first_name
            last_name
            user_id
            username
        }
      }
    }
  `;

  let addPinMutationTxt = `
    mutation conferenceAddPinMutation($conferenceId: Int!, $isAdmin: String!) {
      conferenceAddPin(conferenceId:$conferenceId, isAdmin:$isAdmin) {
        conference_id
        name
        user_id
        record
        transcribe
        email_address
        share_with_account
        conference_type
        pins {
            pin
            is_admin
            is_active
            token
        }
        users {
            user_id
            first_name
            last_name
            user_id
            username
        }
      }
    }
  `;

import ConferencePermissions from './conference-settings-permissions';
import ConferenceCommon from '../mixins/conferencecommon.vue';

export default {
  data: function() {
    return {
      meetingTypeOptions: ["Meeting", "Presentation"],
    }
  },
  props: {conf: Object},
  components: {
    'conference-permissions' : ConferencePermissions,
  },
  mixins: [ConferenceCommon],
  methods: {
    selectConferenceType: function () {
      let self = this;
      const gqlClient = global.gqlClient();
      let variables = {
          conferenceId: parseInt(this.conf.conference_id),
          conferenceType: this.conf.conference_type,
          emailAddress: this.conf.email_address,
        }
      gqlClient.request(updateConferenceMutationTxt, variables).then(function(result) {
          let c = result.conferenceUpdate;
          self.$store.commit('conference/updateConferences',c);
      });
    },
    addLeaderPin: function() {
        this.addPin('Y','N');
    },
    addGuestPin: function() {
      this.addPin('N','Y');
    },
    addPin: function(admin) {
      let self = this;
      let isAdmin = 'Y';
      if (admin!='Y')
        isAdmin = 'N';

      let variables = {
          conferenceId: parseInt(self.conf.conference_id),
          isAdmin
      }
      const gqlClient = global.gqlClient();
      gqlClient.request(addPinMutationTxt, variables).then(function(result) {
        let c = result.conferenceAddPin;
        self.$store.commit('conference/conference',c);
      });
    },
    deleteConferencePin: function (pin) {
        let self = this;

        let remainingCount = 0;
        for (let i=0;i<this.conf.pins.length;i++) {
          let p = this.conf.pins[i];
          
          if (p.pin != pin.pin) {
            console.log(p.is_admin);
            console.log(pin.is_admin);
            console.log(pin);
            if (p.is_admin == pin.is_admin) {
              console.log(p);
              remainingCount++;
            }
          }
        }

        if (remainingCount) {
          const gqlClient = global.gqlClient();
          let variables = {
              conferenceId: parseInt(self.conf.conference_id),
              pin: pin.pin,
            }
          gqlClient.request(deletePinMutationTxt, variables).then(function(result) {
              let c = result.conferenceDeletePin;
              self.$store.commit('conference/conference',c);
          });
        }
    },
  },
  computed: {
    
  },
  async mounted() {
    
  }
}
</script>
